module.exports = __webpack_public_path__ + "static/Screen Shot 2020-07-21 at 2.36.53 PM-2eb448fd786041575d99d42542612525.png";